import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../../shared/services/payment.service';
import { PaymentResult } from '../../../model/payment.result';
import { SubjectService } from '../../../shared/services/subject/subject.service';
import { PaymentMethod } from '../../../model/payment-method';
import { CheckoutResultPageGuidelines } from '../../../model/checkout-result-page-guidelines';
import { TextService } from '../../../shared/services/text.service';
import { SessionService } from '../../../shared/services/session.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { Error } from "../../../model/netmera-events/error";

@Component({
  selector: 'pa-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent implements OnInit {

  paymentResult: PaymentResult;
  textService: TextService;
  trackingId: string;
  merchantCode: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private route: ActivatedRoute, private paymentService: PaymentService, private sessionService: SessionService,
              private subjectService: SubjectService, textService: TextService, private netmeraService: NetmeraService, private error: Error) {
    this.textService = textService;
    this.browserBackButtonBlocking();
  }

  ngOnInit(): void {
    this.subjectService.checkoutResultPageGuidelines(this.populateCheckOutResultPageGuidelines());
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        if (response !== null) {
          this.merchantCode = response.requestHeader?.merchant?.merchantCode;
          this.sdkInitTexts = response.sdkInitTexts;
          this.route.queryParams.subscribe(params => {
            let id: string = params.id;
            this.paymentService.getPaymentResult(id, this.trackingId).subscribe(
              response => {
                this.paymentResult = response;
                if(this.paymentResult?.timeout) {
                  this.netmeraService.pushEvent(this.error.setEventObject("TimeoutIadeUyarı", this.merchantCode));
                }
              },
              error => {
                this.router.navigate(['/result/error', this.trackingId]);
              }
            );
          });
        }
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    });
  }

  determinePaymentType(paymentMethod: PaymentMethod): string {
    if (paymentMethod?.paymentMethodType === 'CREDIT_CARD' && paymentMethod?.cardBrand === 'PCARD') {
      return 'Paycell Kartım';
    } else if (paymentMethod?.paymentMethodType === 'CREDIT_CARD') {
      return 'Kredi Kartım';
    } else if (paymentMethod?.paymentMethodType === 'DCB') {
      return 'Faturana Yansıt Limitim'
    } else if (paymentMethod?.paymentMethodType === 'PAYE_CARD') {
      return 'Paye Kartım'
    }
    return paymentMethod?.paymentMethodType;
  }

  populateCheckOutResultPageGuidelines() {
    let checkOutResultPageGuidelines: CheckoutResultPageGuidelines = new CheckoutResultPageGuidelines();
    checkOutResultPageGuidelines.countDownShow = false;
    checkOutResultPageGuidelines.returnButtonShow = false;
    return checkOutResultPageGuidelines;
  }

  browserBackButtonBlocking() {
    history.pushState(null, null, location.href);
    history.back();
    history.forward();
    window.onpopstate = function () {
      history.go(1);
    };
  }

}
